import React, { useRef } from 'react';
import { IoCalendarSharp } from 'react-icons/io5';
import { FiChevronDown, FiPlus, FiFilter } from 'react-icons/fi';

const RotaOverview = ({
  selectedDate,
  setSelectedDate,
}) => {
  const dateInputRef = useRef(null);

  const formattedDate = selectedDate
    ? new Date(`${selectedDate}T00:00:00`).toLocaleDateString('en-GB', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
    : 'Today';

  const openDatePicker = () => {
    if (dateInputRef.current?.showPicker) {
      dateInputRef.current.showPicker();
    } else {
      dateInputRef.current?.click();
    }
  };

  return (
    <section className="flex justify-between items-center">
      {/* Left Text Content */}
      <div>
        <h1 className="text-2xl font-bold text-slate-900">
          Good morning, Arslan 👋
        </h1>

        <p className="text-sm text-slate-500 mt-1">
          Here's what's happening at Aaziraone Restaurant today.
        </p>
      </div>

      {/* Right Action Buttons */}
      <div className="flex items-center gap-3">

        {/* Date Selector */}
        <button
          type="button"
          onClick={openDatePicker}
          className="flex items-center gap-2 border border-slate-200 rounded-lg px-3 py-2 text-xs font-medium text-slate-800 bg-white cursor-pointer shadow-sm hover:bg-slate-50"
        >
          <IoCalendarSharp className="text-slate-700 text-sm" />

          <span>
            {selectedDate ? formattedDate : 'Select Date'}
          </span>

          <FiChevronDown className="text-slate-400 text-sm ml-1" />
        </button>

        {/* Hidden Date Input */}
        <input
          ref={dateInputRef}
          type="date"
          value={selectedDate || ''}
          onChange={(e) => setSelectedDate(e.target.value)}
          className="absolute opacity-0 pointer-events-none"
        />
      </div>
    </section>
  );
};

export default RotaOverview;
